module.exports = __webpack_public_path__ + "static/media/app-icon.e24800a6.png";